import Activity from '../../schema/Activity';
import Role from '../../schema/innerSchema/Role';

export default function createEntitiesPrimaryHash(activities: Activity[]): any {
    if (activities) {
        let mapEntitiesActivities = {};
        activities.forEach(activityItem => {
            if (activityItem) {
                if (activityItem.role == Role.Primary) {
                    let entityId = activityItem.entityId;
                    if (mapEntitiesActivities[entityId]) {
                        mapEntitiesActivities[entityId] += 1;
                    } else {
                        mapEntitiesActivities[entityId] = 1;
                    }
                }
            }
        });
        return mapEntitiesActivities;
    }
    return null;
}
